import { Lead } from "../../../../Models/Lead";
import SessionContextValueProvider from "../../../Providers/Value/SessionContextValueProvider";
import UserContextValueProvider from "../../../Providers/Value/UserContextValueProvider";
import IntroConfirmation from "../Components/IntroConfirmation";

/** Provides the Customer First Name and Lead External System Session Context properties. */
const SessionContextGreeting = SessionContextValueProvider({
  Component: IntroConfirmation,
  map: ({ customer, lead }) => {
    return {
      customerFirstName: customer.firstName,
      outbound: Lead.isOutboundDirection(lead)
    };
  }
});

/** Provides the User First Name User Context Property. */
const UserAndSessionContextConfirmation = UserContextValueProvider({
  Component: SessionContextGreeting,
  map: ({ user }) => {
    return { userFirstName: user.firstName };
  }
});

export default UserAndSessionContextConfirmation;
